import accounting from 'accounting'

export default {
    data () {
        return {
            bets: [],
            EventGroup: [],
            walletType: 1,
            firstCombineSelected: false,
            maxStake: 0,
            currentFixtureState: 0,
            selectedBets: [],
            confirmationType: 2,
            sameEvents: 0,
            subEarnings: 0,
            couponTypes: [
                {type: 'single', id: 1},
                {type: 'multiple', id: 2},
                {type: 'system', id: 3}
            ],
            confirmationTypes: [
                {name: 'agreement_high_odds', id: 1},
                {name: 'agreement', id: 2},
            ]
        }
    },
    methods: {
        changeWalletType (type){
            this.walletType = type;
        },
        getBetListGroup () {
          this.bets.forEach((item) => {
              if(this.findByKey(this.EventGroup, 'eventId', item.eventId)){

                  this.findByKey(this.EventGroup, 'eventId', item.eventId).bets.push(item);

              }else {
                  this.EventGroup.push({
                      eventId: item.match.matchId,
                      match: item.match,
                      bets: [item]
                  });
              }
          });

        },
        addBet(bet, market, match) {

            if (!bet.active) {
                return false;
            }

            if (bet.odd === '1.00') {
                return false;
            }

            console.log(match)

            var bet = {
                eventId: match.matchId,
                name: market.name,
                oddId: bet.id,
                exc: bet.exc,
                oddType: bet.oddType,
                odd: bet.odd,
                outCome: bet.outcome,
                checked: true,
                specialValue: market.sp,
                stake: 0.00,
                banker: false,
                match: match,
                active: bet.active,
                live: bet.live,
                tss: match.ts
            };
            this.$getItem('bets', (key, value) => {
                //console.log all the kay/value pairs

                if(!value) {
                    value = [];
                } 

                if (this.findByKey(value, 'oddId', bet.oddId)) {
                    this.findByKeyAndRemove(value, 'oddId', bet.oddId);

                    //document.querySelector(".odd-c-"+bet.oddId).classList.remove('active');

                    this.$store.commit("removeMarket", bet);
                    
                }else{

                    if( this.findByKey(value, 'oddId', bet.eventId) ) {
                        this.findByKeyAndRemove(value, 'oddId', bet.eventId);

                        value.push(bet);
                    }else{
                        value.push(bet);
                    }
                }


                //console.log(value);
                this.updateBets(value);
                //setTimeout(this.detectSameEvents(), 300);

            }, function (err) {

                this.$setItem('bets', []);
            })
            //this.checkBetCurrentValue();
        },
        selectSystem (system, s) {
            if (typeof this.selectedSystem[s] === 'object' ) {
                this.selectedSystem[s] = undefined;
            } else {
                this.selectedSystem[s] = system;
            }
            this.fetchBets();
        },
        computeCoupon (coupon) {
            var odd = 1;

            if (typeof coupon === 'object' ) {
                for (var i = 0; i < coupon.length; i++) {
                    odd = Number(odd * coupon[i].odd);

                }
            }

            if (this.activeType == 3) {
                for (var i = 0; i < this.bankers.length; i++) {
                    odd = Number(odd * this.bankers[i].odd) ;
                }
            }

            return odd;
        },
        computeOdds () {

            if (this.bets.length > 10 && this.activeType == 3) {
                this.activeType = 2;
            }

            if(this.sameEvents.length > 0)
                this.activeType = 1;

            this.odds = 0;

            var odd = [];
            if (this.activeType == 3) {
                var systemOdd = 0;
                this.totalBets = 0;
                this.odds = 0;   
                this.totalBonus = 0;             

                for (var is = 0; is < this.selectedSystem.length; is++) {

                    if ( this.isSelectedSystem(is) ) {
                        odd[is] = [];
                        this.totalBets += this.selectedSystem[is].bets;
                    }

                }

                this.betPer = this.amount / this.totalBets;

                for (var i = 0; i < this.systemCombinations.length; i++) {
                    var perBet = 0
                    if (this.isSelectedSystem(this.systemCombinations[i].length)) {
                        //odd[this.systemCombinations[i].length].push(Number(this.computeCoupon(this.systemCombinations[i])));
                        this.odds += Number(this.computeCoupon(this.systemCombinations[i]));
                        //perBet = this.amount / this.selectedSystem[this.systemCombinations[i].length].bets;
                        perBet = this.betPer;
                        this.totalBonus += perBet * this.computeCoupon(this.systemCombinations[i])
                    }
                }

                for (var i = 0; i < this.bankers.length; i++) {

                    this.odds = Number(this.odds * this.bankers[i].odd) ;

                }
            }

            if (this.activeType == 2) {
                this.odds = 1;
                this.totalBets = 1;

                for (var i = 0; i < this.bets.length; i++) {

                    this.odds = (this.bets[i].checked) ? Number(this.odds * this.bets[i].odd) : this.odds;

                }
            }

            if (this.activeType == 1) {
                this.odds = 1;
                this.totalBets = 0;
                this.totalBonus = 0;

                var perBetAmountTotal = 0;
                var perBetAmount = Number(this.toFloat(this.amount) / this.bets.length).formatMoney(2, '.', ',');
                this.betPer = perBetAmount;

                for (var i = 0; i < this.bets.length; i++) {

                    this.odds = (this.bets[i].checked) ? Number(this.odds * this.bets[i].odd) : this.odds;
                    this.bets[i].stake = perBetAmount;

                    this.totalBets += (this.bets[i].checked) ? 1 : 0;

                    this.totalBonus += Number(this.bets[i].stake * this.bets[i].odd);

                }

            }

        },
        prepareBets () {

            var a = [];
            this.bets.forEach((item) => {

                a.push(
                    {
                        eventId: item.eventId,
                        banker: item.banker,
                        odd: item.odd,
                        oddId: item.oddId,
                        exc: item.exc,
                        isLive: item.live,
                        ts: item.tss
                    }
                )
            })
            return a;
        },
        checkBetCurrentValue () {
            this.prepareBets()
            var AppId = this.$root.app.id;

            this.$http.post(bsapi+'api/v1/checkBets', {walletType: this.walletType, type: this.activeType,bets: this.prepareBets(), systems: this.getActiveSystems(), amount: this.toFloat(this.amount),
                    appToken: window.auth.accessToken, app:AppId},
                { headers: { 'X-App': '' +AppId } }

            ).then(
                response => {
                    // get body data
                    this.maxStake = response.body.maxStake;

                    if (response.body.errors.bets) {
                        this.betErrors = [];
                        setTimeout(() => {
                            this.betErrors = response.body.errors.bets;
                        }, 1000);
                    }else {
                        this.betErrors = [];
                    }

                    if(response.body.bets) {

                        response.body.bets.forEach( (v,k) => {

                            this.bets.forEach((item) => {

                                //var cm = (item.oddType === 5500 || item.oddType === 5520) ? (item.tss === v.entity.match.total_score) : true;

                                //if(!cm)
                                  //  this.betErrors[item.oddId] = {msg: "Closed"}

                                if(item.oddId == v.entity.id)
                                {
                                    item.odd = v.value;
                                    item.maxStake = v.entity.playable_max_stake;
                                }

                            })

                        })

                        this.updateBets(this.bets);
                    }

                }, response => {


                })
        },
        reuseBet(id){
            this.$http.get(bsapi + 'api/v1/bet/detail/'+id, {
                params: {
                    _locale: session.locale.locale
                }
            }).then(response => {
                var value = [];
                response.body.result.items.forEach((i) => {

                    var bet = {id: i.selectionId, exc: '', outcome: i.selection, sp: '', odd: i.oddValue
                        , oddType: i.oddType, active: 1, live: 1};
                    var market = {name: i.name}
                    var match = {matchId: i.mid, name: i.fcName +' - '+ i.scName, competitor: {oneName: i.fcName, twoName: i.scName}};

                    var bet = {
                        eventId: match.matchId,
                        name: market.name,
                        oddId: bet.id,
                        exc: bet.exc,
                        oddType: bet.oddType,
                        odd: bet.odd,
                        outCome: bet.outcome,
                        checked: true,
                        specialValue: bet.sp,
                        stake: 0.00,
                        banker: false,
                        match: match,
                        active: bet.active,
                        live: bet.live
                    };

                })

                this.$setItem('bets', value);
                //console.log(value);
                this.updateBets(value);

                setTimeout(() => {
                    this.$router.replace({name: 'betSlip'})
                }, 2000)
            })
        },
        betPlace (amount = 0) {
            this.checkBetCurrentValue();

            if(amount > 0)
                this.amount = amount;

            if (window.session.uid == 0) {
                swal(this.t.processing.error, this.t.auth.bet_auth, "error")
                return false
            }

            this.$bus.$emit('betCreating', true);

            var AppId = this.$root.app.id;

            this.$http.post(bsapi+'api/v1/betPlace', {
                walletType: this.walletType, confirmationType: this.confirmationType,
                    type: this.activeType,bets: this.prepareBets(), systems: this.getActiveSystems(),
                    amount: this.toFloat(this.amount), appToken: window.auth.accessToken, app:AppId},

                { headers: { 'X-App': '' +AppId } }

            ).then(
                response => {
                    // get body data

                    this.$bus.$emit('betCreated', true);
                    setTimeout(this.clear, 1500);

                }, response => {

                    if (response.body.error == 'bet_error') {
                        this.$bus.$emit('betError', true);

                        this.errors = response.body.errors;

                        if (response.body.errors.bets) {
                            this.betErrors = response.body.errors.bets;
                        }
                    }else {
                        this.errors = null;
                    }
                })
        },
        getActiveSystems () {
            var activeSystems = new Array();

            if(this.selectedSystem) {
                for (var i = 0; i < this.selectedSystem.length; i++) {
                    if (typeof this.selectedSystem[i] === 'object') {
                        activeSystems.push(i);
                    }
                }
            }

            return Array.from(new Set(activeSystems) );
        },
        isSelectedSystem (s) {
            if (typeof this.selectedSystem[s] === 'object' ) {
                return true;
            } else {
                return false;
            }
        },
        syncSelectionClass () {

            //var list;
            //list = document.querySelectorAll('.active-odd-button');
            //for (var i = 0; i < list.length; ++i) {
             //   list[i].classList.remove('active-odd-button');
           // }

            this.$getItem('bets', (key, value) => {

                /*
                value.forEach((v, k) => {
                    var list;
                    //list = document.querySelectorAll('.odd-c-'+v.oddId);
                    for (var i = 0; i < list.length; ++i) {
                      //list[i].classList.add('active-odd-button');
                    }
                });
                */
            });
        },
        updateBets (bets) {

            this.$setItem('bets', bets, (key, value) => {
                this.$bus.$emit('addBet', bets);
                //this.syncSelectionClass();

                value.forEach((v,k) => {
                    this.$store.commit("updateActiveMarket", v);
                })
            });

            this.detectSameEvents(bets)

            this.$setItem('selectedBets', this.selectedBets, (key, value) => {

            });

            this.getBetListGroup()
        },
        detectSameEvents (bets) {
            this.sameEvents = 0;

            this.couponTypes = [
                {type: 'single', id: 1},
                {type: 'multiple', id: 2},
                {type: 'system', id: 3}
            ];

            bets.forEach((v) => {

                if(this.findByKeyCount(bets, 'eventId', v.eventId) > 1){

                    if( this.activeType == 2 || this.activeType == 1){
                        this.sameEvents = 1;
                        this.activeType = 1;
                        this.currentType = 1;
                    }

                    this.couponTypes = [
                        {type: 'single', id: 1},
                    ];
                }
            })
        },
        removeBet (bet) {
            this.findByKeyAndRemove(this.bets,'oddId', bet.oddId);
            this.$store.commit("removeMarket", bet);
            this.bet = this.bets;
            this.updateBets(this.bets)
            //this.checkBetCurrentValue();
        },
        clear () {
            this.$getItem('bets', (key, value) => {

                value.forEach((v,k) => {
                    setTimeout(() => {
                        this.$store.commit("removeMarket", v);
                    }, 100)
                })
            });
            this.updateBets([]);
        },
        isBetAvailable (oddId) {
            if (typeof this.betErrors[oddId] !== 'undefined') {
                // your code here
                return this.betErrors[oddId];
            }
            return false;
        },
        setBanker (bet) {

            if ( 3 < (this.bets.length - this.bankers.length) ) {
                bet.banker = (bet.banker) ? false : true;
            }else {
                bet.banker = false;
            }

            this.updateBets(this.bets);

            this.selectedSystem = [];
        },
        changeCouponType  (type) {

            this.activeType = type;
            this.selectedSystem = [];

            if (this.bets.length > 10 && type == 3) {
                this.activeType = 2;
            }
            this.fetchBets();
        },
        fetchBets() {
            this.$getItem('bets', (key, value) => {
                //console.log all the kay/value pairs

                if (!value){
                    this.updateBets([]);
                }

                this.bets = value;

                if(this.bets.length > 1 && !this.firstCombineSelected && this.sameEvents === 0){

                    this.activeType = 2;
                    this.currentType = 2;

                    this.firstCombineSelected = true;
                }else if(this.firstCombineSelected && this.bets.length == 1) {
                    this.activeType = 1;
                    this.currentType = 1;
                    this.firstCombineSelected = false;
                }

                if (this.activeType == 3) {
                    this.fetchSystemBets();
                    this.systemCombinations = this.combinations(this.systemBets);
                    this.possibleCombinations = this.getPossibleCombinations(this.systemBets);
                }

                this.computeOdds();



            }, function (err) {

            })

        },
        getOutcomeSelection (OutCome, Match) {
            var ou;

            return OutCome;
        },
        openMatch (m) {

            this.$bus.$emit('openMatchOdd', m);
        },
        findByKeyCount (source, key, find) {
            var count = 0;
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === find) {
                    count = count + 1;
                }
            }
            return count;
        },
        findByKey (source, key, find) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === find) {
                    return source[i];
                }
            }
            return false;
        },
        findByKeyAndRemove (source, key, id) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === id) {
                    source.splice(i, 1);
                }
            }
            return false;
        },
        getPossibleCombinations (set) {
            var k, i, combs, k_combs;
            combs = [];

            // Calculate all non-empty k-combinations
            for (k = 1; k <= set.length; k++) {
                k_combs = this.combinationSets(set, k);

                for (i = 0; i < k_combs.length; i++) {
                    combs[k_combs[i].length] = (combs[k_combs[i].length]) ? {system: k_combs[i].length, bets: Number ( combs[k_combs[i].length].bets + 1), selected: this.isSelectedSystem(i)} : {system: k_combs[i].length, bets: 1, selected: this.isSelectedSystem(i)};
                }
            }
            return combs;
        },
        combinations (set) {
            var k, i, combs, k_combs;
            combs = [];

            // Calculate all non-empty k-combinations
            for (k = 1; k <= set.length; k++) {
                k_combs = this.combinationSets(set, k);
                for (i = 0; i < k_combs.length; i++) {
                    combs.push(k_combs[i]);
                }
            }
            return combs;
        },
        combinationSets (set, k) {
            var i, j, combs, head, tailcombs;

            // There is no way to take e.g. sets of 5 elements from
            // a set of 4.
            if (k > set.length || k <= 0) {
                return [];
            }

            // K-sized set has only one K-sized subset.
            if (k == set.length) {
                return [set];
            }

            // There is N 1-sized subsets in a N-sized set.
            if (k == 1) {
                combs = [];
                for (i = 0; i < set.length; i++) {
                    combs.push([set[i]]);
                }
                return combs;
            }

            combs = [];
            for (i = 0; i < set.length - k + 1; i++) {
                // head is a list that includes only our current element.
                head = set.slice(i, i + 1);
                // We take smaller combinations from the subsequent elements
                tailcombs = this.combinationSets(set.slice(i + 1), k - 1);
                // For each (k-1)-combination we join it with the current
                // and store it to the set of k-combinations.
                for (j = 0; j < tailcombs.length; j++) {
                    combs.push(head.concat(tailcombs[j]));
                }
            }
            return combs;
        },
        toFloat (e) {
            if (typeof (e) === 'number') return e;
            if (typeof (e) === 'string') {
                var str = e.trim();
                var value = Number(e.replace(/[^0-9.-]+/g, ""));
                return str.startsWith('(') && str.endsWith(')') ? -value: value;
            }

            return e;
        },
        cashout (id) {
            var AppId = this.$root.app.id;
            return this.$http.get(bsapi+'api/v1/bet-cash-out/'+id, { headers: { 'X-App': '' +AppId } });
        },
        cashoutNow (id) {
            var AppId = this.$root.app.id;
            return this.$http.post(bsapi+'api/v1/bet-cash-out/'+id, {}, { headers: { 'X-App': '' +AppId } });
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/betSlip.js